export default {
  GET_SOURCES_OF_RESOURCES_QUERY_SERVICE: Symbol.for('GET_SOURCES_OF_RESOURCES_QUERY_SERVICE'),
  SOURCE_OF_RESOURCES_REPOSITORY: Symbol.for('SOURCE_OF_RESOURCES_REPOSITORY'),
  SOURCE_OF_RESOURCES_STATE_MANAGER: Symbol.for('SOURCE_OF_RESOURCES_STATE_MANAGER'),
};
